(function(app, ng) {
    dialogCtrl.$inject = ["$mdDialog", "_", "eligibilityFormApi"];
    app.controller("dialogCtrl", dialogCtrl);

    function dialogCtrl($mdDialog, _, eligibilityFormApi) {
        var $ctrl = this;
        $ctrl.UI = { isSubmitting: false };
        var classes = function(q) {
            //return {
            //    "question-small": ["Address", "City", "State", "Zip Code"].indexOf(q.SurveyQuestionText) === -1,
            //    "question-smaller": q.SurveyQuestionText === "Address",
            //    "question-smallest": ["City", "State", "Zip Code"].indexOf(q.SurveyQuestionText) !== -1
            //};
            return {
                "col-md-6": ["Address", "City", "State", "Zip Code", "Which program are you interested in", "What is your current ESTIMATED annual gross production?"].indexOf(q.SurveyQuestionText) === -1,
                "col-md-12": q.SurveyQuestionText === "Which program are you interested in" || q.SurveyQuestionText === "Address",
                //"col-md-12": ,
                //"col-md-2": ["City", "State", "Zip Code"].indexOf(q.SurveyQuestionText) !== -1,
                "col-md-6 col-md-offset-3": q.SurveyQuestionText === "What is your current ESTIMATED annual gross production?"
            };
        };

        var answers = [];
        
        ng.extend($ctrl,
        {
            classes: classes,
            questionAnswered: questionAnswered,
            questionAnsweredNoText: questionAnsweredNoText,
            checkboxAnswered: checkboxAnswered,
            closeDialog: closeDialog,
            submit: submit,
            checkboxRequiredAnswered: checkboxRequiredAnswered
        });

        function questionAnswered(questionId, id, answer) { 
            
            var obj = _.find(answers, { SurveyQuestionId: questionId, SurveyQuestionPossibleAnswerId: id });    
           
            if (obj) {
                obj.SurveyQuestionPossibleAnswerId = id;
                obj.TextValue = answer;
            } else {
                answers.push({
                    SurveyQuestionId: questionId,
                    SurveyQuestionPossibleAnswerId: id,
                    TextValue: answer
                });
            }
        }

        function questionAnsweredNoText(questionId, id) {
            questionAnswered(questionId, id, "default");
        }

        function checkboxAnswered(questionId, id) {
            var obj = _.find(answers, { SurveyQuestionId: questionId, SurveyQuestionPossibleAnswerId: id });

            if (obj)
                answers.splice(answers.indexOf(obj), 1);
            else
                answers.push({
                    SurveyQuestionId: questionId,
                    SurveyQuestionPossibleAnswerId: id,
                    TextValue: "default"
                });
        }

        function checkboxRequiredAnswered(questionId) {        
            var obj = _.find(answers, { SurveyQuestionId: questionId });
            if (obj) {
                return true;
            }
            return false;           
        }
        
        function closeDialog($event) {           
            $mdDialog.hide(false);
        }

        function submit() {
           
            $ctrl.UI.isSubmitting = true;

            answers.forEach(function(a) {
                delete a.SurveyQuestionID;
            });

            eligibilityFormApi.submit($ctrl.surveyId, answers).then(function() {
                $mdDialog.hide(true);
            }, function() {
                $mdDialog.hide(false).then(function() {
                    $mdDialog.show($mdDialog.alert().title("Form submission failed.").ok("Ok"));
                });
            });
        }
    }
})(window.app, window.angular); // jshint ignore:line